import { ZfCheckbox, ZfIcon, ZfListItem, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { TalkingPointDto } from '../../../api/generated/client';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { useHandleTalkingPointPin } from '../../../hooks/useHandleTalkingPointPin';
import { useNumberSearchParams } from '../../../hooks/useNumberSearchParams';

interface IProps {
    point: TalkingPointDto;
    showLeadingCheckbox: boolean;
    hasBorderBottom?: boolean;
}

export const TopicListItem: FunctionComponent<IProps> = ({ point, showLeadingCheckbox, hasBorderBottom }) => {
    const { i18n } = useTranslation();
    const { setActiveTalkingPoint, setActiveAdvisoryNeed } = useNeedContentContext();
    const [pointId] = useNumberSearchParams('point');
    const [isTalkingPointPinned, handleOnCheckboxClick] = useHandleTalkingPointPin(point.id);

    const onItemClick = () => {
        setActiveTalkingPoint(point);
        setActiveAdvisoryNeed(undefined);
    };

    return (
        <ZfStack style={{ borderBottom: hasBorderBottom ? '1px solid var(--border-color-default-normal)' : '' }}>
            <ZfListItem
                size="large"
                titleText={point.name[i18n.language]}
                select={point.id === pointId}
                state={point.id === pointId ? 'selected' : 'default'}
                onListItemSelect={onItemClick}
            >
                {showLeadingCheckbox ? (
                    <ZfCheckbox
                        slot="leading"
                        tabIndex={-1}
                        checked={isTalkingPointPinned}
                        onCheckboxCheck={handleOnCheckboxClick}
                        onClick={(event) => event.stopPropagation()}
                    />
                ) : null}
                <ZfIcon slot="trailing" name="chevron_right" size="extra-extra-large" style={{ padding: `var(--padding-vertical-xxl) 0` }} />
            </ZfListItem>
        </ZfStack>
    );
};
